import { useEffect, useRef, useState } from 'react';

export default function CTASection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-32 lg:py-40 bg-gradient-to-br from-[#0A1628] via-[#0D1B35] to-[#050B14] overflow-hidden"
    >
      {/* Decorative icons */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 text-[#D4AF37] text-6xl">
          <i className="ri-line-chart-line"></i>
        </div>
        <div className="absolute top-40 right-20 text-[#D4AF37] text-5xl">
          <i className="ri-shield-check-line"></i>
        </div>
        <div className="absolute bottom-32 left-1/4 text-[#D4AF37] text-7xl">
          <i className="ri-global-line"></i>
        </div>
        <div className="absolute bottom-20 right-1/3 text-[#D4AF37] text-5xl">
          <i className="ri-briefcase-line"></i>
        </div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 text-center relative z-10">
        <h2 
          className={`text-4xl lg:text-6xl font-bold text-white mb-6 font-['Playfair_Display'] transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Готови ли сте да обсъдим стратегия?
        </h2>
        
        <p 
          className={`text-xl lg:text-2xl text-[#B8C5D6] font-light mb-12 font-['Inter'] transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Свържете се за консултация по управление на капитал
        </p>

        <a
          href="https://t.me/NikLiev"
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-3 px-12 py-5 bg-[#D4AF37] text-white rounded-full text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(212,175,55,0.6)] cursor-pointer whitespace-nowrap ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          Пишете в Telegram
          <i className="ri-telegram-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
